import { TypedDocumentNode, gql } from '@apollo/client';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import { generatePath } from 'react-router-dom';
import styled from 'styled-components';

import IconButton from '@sorare/core/src/atoms/buttons/IconButton';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineL } from '@sorare/core/src/atoms/typography';
import { FOOTBALL_PLAY_RIVALS_LEAGUES_SLUG_SETTINGS } from '@sorare/core/src/constants/__generated__/routes';
import useQuery from '@sorare/core/src/hooks/graphql/useQuery';
import useSafePreviousNavigate from '@sorare/core/src/hooks/useSafePreviousNavigate';
import { glossary } from '@sorare/core/src/lib/glossary';
import { useTypedParams } from '@sorare/core/src/lib/routing';

import { RivalsUserGroupAvatarEdit } from 'components/rivalsUserGroup/RivalsUserGroupAvatarEdit';

import {
  AvatarEditPageQuery,
  AvatarEditPageQueryVariables,
} from './__generated__/page.graphql';
import { PageParams } from './__generated__/routeParams';

const Wrapper = styled(Vertical)`
  padding: var(--double-unit);
  background: var(--c-neutral-200);
  height: var(--100vh);
  overflow-y: hidden;
`;

const AVATAR_EDIT_PAGE_QUERY = gql`
  query AvatarEditPageQuery($slug: String!) {
    football {
      rivals {
        id
        userGroup(slug: $slug) {
          slug
          id
        }
      }
    }
  }
` as TypedDocumentNode<AvatarEditPageQuery, AvatarEditPageQueryVariables>;

const AvatarEditPage = () => {
  const { slug: userGroupSlug } = useTypedParams<PageParams>();
  const { data } = useQuery(AVATAR_EDIT_PAGE_QUERY, {
    variables: { slug: userGroupSlug },
  });
  const onBack = useSafePreviousNavigate(
    generatePath(FOOTBALL_PLAY_RIVALS_LEAGUES_SLUG_SETTINGS, {
      slug: userGroupSlug,
    })
  );
  const userGroup = data?.football.rivals.userGroup;
  return (
    <Wrapper gap={2}>
      <IconButton color="tertiary" icon={faChevronLeft} onClick={onBack} />
      <HeadlineL>
        <FormattedMessage {...glossary.avatar} />
      </HeadlineL>
      {userGroup && (
        <RivalsUserGroupAvatarEdit userGroupId={userGroup.id} onDone={onBack} />
      )}
    </Wrapper>
  );
};
export default AvatarEditPage;
